function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "dotted-separator_svg__a",
  d: "M251 5027h714v1H251z"
}), React.createElement("mask", {
  id: "dotted-separator_svg__b",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 714,
  height: 1,
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#dotted-separator_svg__a"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  mask: "url(#dotted-separator_svg__b)",
  xlinkHref: "#dotted-separator_svg__a",
  transform: "translate(-251 -5027)",
  stroke: "#000",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.75,
  strokeDasharray: "1,7"
});

var SvgDottedSeparator = function SvgDottedSeparator(props) {
  return React.createElement("svg", _extends({
    width: 713,
    height: 1,
    viewBox: "0 0 713 1"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='713px' height='1px' viewBox='0 0 713 1' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com --%3E %3Ctitle%3Edotted_separator%3C/title%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cdefs%3E %3Cpolygon id='path-1' points='251 5027 965 5027 965 5028 251 5028'%3E%3C/polygon%3E %3Cmask id='mask-2' maskContentUnits='userSpaceOnUse' maskUnits='objectBoundingBox' x='0' y='0' width='714' height='1' fill='white'%3E %3Cuse xlink:href='%23path-1'%3E%3C/use%3E %3C/mask%3E %3C/defs%3E %3Cg id='Finals' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' opacity='0.75' stroke-dasharray='1,7'%3E %3Cg id='Lesson-Page-elements' transform='translate(-251.000000, -5027.000000)' stroke='%23000000' stroke-width='2'%3E %3Cuse id='dotted_separator' mask='url(%23mask-2)' xlink:href='%23path-1'%3E%3C/use%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgDottedSeparator as ReactComponent };